import React, { useEffect, useState } from 'react';
import { ZoomMtg } from '@zoom/meetingsdk'
import ZoomPopEnquery from './ZoomPopEnquiry';

const MeetPage = () => {
  const [defaulPage, setDefaultPage] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [userData, setUserData] = useState(null);


  // const handleClick = () => {
  //   window.open('https://us06web.zoom.us/j/9913113113');
  // };

  const handleUserData = (data) => {
    setUserData(data);
    setDefaultPage(false)
  };
  const handleClosePopup = () => {
    setIsPopupOpen(false);
    // setFormMessage(true)
  };

  useEffect(() => {
    const generateSignature = async () => {
      try {
        const response = await fetch('https://backend.globedwise.com/zoom/generateSignature', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ role: "0" }),
        });

        const data = await response.json();
        // console.log(data)
        return data.sdkJWT;
      } catch (error) {
        console.error('Error generating signature:', error);
        return undefined;
      }
    };

    const joinMeeting = async () => {
      // setFormMessage(false)

      ZoomMtg.preLoadWasm()
      ZoomMtg.prepareWebSDK()
      try {
        const signature = await generateSignature();
        if (!signature) {
          setDefaultPage(true);
          // toast.error("Sorry, something went wrong.")
          return console.log("Signature is required");
        }
        ZoomMtg.init({
          leaveUrl: 'https://www.bibektrust.org/',
          success: (success) => {
            ZoomMtg.join({
              meetingNumber: process.env.REACT_APP_MEETING_ID,
              // role: 0,
              signature,
              passWord: process.env.REACT_APP_PASSCODE,
              sdkKey: process.env.REACT_APP_API_KEY,
              userName: `${userData?.name}`,
              tk: '',
              success: (success) => {
                console.log('Meeting joined successfully', success);
                localStorage.setItem("hasJoined", "true");
              },
              error: (error) => {
                setDefaultPage(true)
                // toast.error("Something Went Wrong")
                // setErrorMessage(true)
                // clearTimeout(timeoutId);
                console.log('Error joining meeting', error);
              },

            })
          }
        })
      } catch (error) {
        // toast.error("Something Went Wrong")
        setDefaultPage(true)
        // setErrorMessage(true)
        // clearTimeout(timeoutId);
        console.error('Error joining meeting:', error);
      }
    }

    if (!defaulPage) {
      joinMeeting();
      console.log(userData, 'user data');
    }
  }, [defaulPage, userData]);

  return (
    <div className="container mx-auto md:py-8 py-6 flex items-center justify-center">
      {defaulPage ?
        <div className="w-full md:flex justify-center gap-4 flex flex-col items-center">
          <div className="relative w-full">
            {/* Image */}
            <img
              src="/assets/zoom-des.jpeg"
              alt="learn Punjabi"
              className="w-full object-cover rounded-md hidden md:block"
            />
            <img
              src="/assets/zoom-mob.jpeg"
              alt="learn Punjabi"
              className="w-full object-cover rounded-md  md:hidden"
            />
            {/* Button - Positioning it at the top right of the image */}
            <button
              onClick={() => setIsPopupOpen(true)}
              className="absolute top-4 right-4 px-6 py-2 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 transition duration-300 blink-button hidden md:block">
              Join Meeting
            </button>
          </div>

          {/* Button for mobile view */}
          <button
            onClick={() => setIsPopupOpen(true)}
            className="md:hidden mt-4 px-6 py-2 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 transition duration-300 blink-button">
            Join Meeting
          </button>
        </div> :

        <div className='zoom-container'>
          <div id="zmmtg-root"></div>
          <div id="aria-notify-area"></div>

          <div className="ReactModalPortal"></div>
          <div className="ReactModalPortal"></div>
          <div className="ReactModalPortal"></div>
          <div className="ReactModalPortal"></div>
          <div className="global-pop-up-box"></div>
          <div className="sharer-controlbar-container sharer-controlbar-container--hidden"></div>
        </div >
      }

      {isPopupOpen && <ZoomPopEnquery isOpen={isPopupOpen} onClose={handleClosePopup} userData={handleUserData} />}
    </div>
  );
};

export default MeetPage;
